import { Fade, Tooltip, TooltipProps } from '@mui/material';
import Modal, { ModalFooter, Sheets } from '@ingka/modal';

import Button from '@ingka/button';
import Checkbox from '@ingka/checkbox';
import SSRIcon from '@ingka/ssr-icon';
import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

export const StyledModel = styled(Modal)`
   z-index: ${tokens.zIndex.modal + 1};
`;

export const StyledModalFooter = styled(ModalFooter)`
   &.modal-footer {
      justify-content: center;
      gap: ${tokens.space.lg};
      padding: ${tokens.space.xxl};
      border-top: ${tokens.border.thin} ${theme.colors.border.default};
   }
`;

export const StyledIconSmall = styled(SSRIcon)`
   margin-left: ${tokens.space.sm};
   margin-right: ${tokens.space.xxs};
   width: 1.2rem;
   height: 1.2rem;
   display: inline-flex;
   vertical-align: middle;
`;

export const ActionButton = styled.button`
   background: none;
   border: none;
   color: ${theme.colors.border.focus};
   font-weight: ${tokens.font.weight.semibold};
   cursor: pointer;
   padding: ${tokens.space.sm} ${tokens.space.md};
   
   &:hover {
      background-color: ${theme.colors.bg.secondary};
   }
`;

export const StyledSheets = styled(Sheets)`
   border-radius: 0;
   z-index: ${tokens.zIndex.modal};
   max-width: fit-content !important;
   
   .MuiListSubheader-root {
      font-weight: ${tokens.font.weight.semibold};
      font-size: ${tokens.font.size.md};
   }
`;

export const StyledSheetDiv = styled.div`
   padding-bottom: ${tokens.space.sm};
`;

export const StyledToolbarButton = styled(Button)`
   margin-left: ${tokens.space.sm};
   &:focus,
   &:focus-visible {
      outline: none;
      box-shadow: none;
   }
`;

export const StyledExpandedEndOfRowButton = styled(Button)`
   background-color: ${theme.colors.bg.secondary};
   border: ${tokens.border.thin} ${theme.colors.bg.tertiary};
`;

export const StyledCheckBox = styled(Checkbox)`
   height: 100%;

   .checkbox__symbol {
      width: 1.2rem;
      height: 1.2rem;
   }

   input[type='checkbox']:checked ~ .checkbox__symbol {
      background-color: ${theme.colors.text.tertiary};
      border-color: ${theme.colors.text.tertiary};
   }

   input[type='checkbox']:checked:hover ~ .checkbox__symbol {
      background-color: ${theme.colors.text.primary};
      border-color: ${theme.colors.text.primary};
   }
`;

export const StyledTooltip = styled(({ className, enterNextDelay = 500, enterDelay = 500, ...other }: TooltipProps) => (
   <Tooltip
      classes={{ tooltip: className }}
      disableFocusListener={true}
      {...other}
      TransitionComponent={Fade}
      enterNextDelay={enterNextDelay}
      enterDelay={enterDelay}
   />
))`
   background-color: ${theme.colors.text.primary};
   color: ${theme.colors.text.inverse};
   font-size: ${tokens.font.size.md} !important;
   font-weight: ${tokens.font.weight.normal};
   padding: ${tokens.space.sm} ${tokens.space.md};
   white-space: pre-line;
`;